var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyesOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7131 9.1324C18.1081 9.64906 18.1081 10.3466 17.7131 10.8624C16.469 12.4866 13.484 15.8307 9.99895 15.8307C6.51395 15.8307 3.52895 12.4866 2.28478 10.8624C2.0926 10.615 1.98828 10.3107 1.98828 9.9974C1.98828 9.68413 2.0926 9.37979 2.28478 9.1324C3.52895 7.50823 6.51395 4.16406 9.99895 4.16406C13.484 4.16406 16.469 7.50823 17.7131 9.1324V9.1324Z",
    stroke: "#41A1EA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "#41A1EA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyesOpen);
export default __webpack_public_path__ + "static/media/icon-eyes-open.0e3f781c33fa5ef7a37fa25e328f1ad2.svg";
export { ForwardRef as ReactComponent };